import VueMonthlyPicker from 'vue-monthly-picker';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import Select2Multiple from 'v-select2-multiple-component';

export default {
  name: "HolidayList",
  components: {
    MainLayout,
    VueMonthlyPicker,
    AdvancedLaravelVuePaginate,
    Loading,
    Select2Multiple
  },

  data() {
    return {
      isFilterOpen: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      search_status: false,
      selectedMonth: null,
      month: null,
      description: "",
      holidayMasterData: {},
      currentAcdYear: null,
      searchedData: null,
      isSearched: false,
      selectedCategory: '',
      selectedType: '',
      typeList: Object.entries(CONFIG.HOLIDAY_TYPE_OPTIONS).map(([id, text]) => ({
        id,
        text
      })),
      categoryList: CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS.map(item => ({
        id: item.id,
        text: item.label,
      })),
      templateLink: '',
      holidayFile: '',
      holidayFileName: '',
      invalidFile: false,
      disabled: false,
      submitted: false,
    };
  },

  watch: {
    selectedMonth(newValue) {
      if (newValue) {
        const adjustedMonth = new Date(newValue);
        adjustedMonth.setMonth(adjustedMonth.getMonth() + 1); // Add one month to adjust for the offset
        this.month = adjustedMonth.toISOString().slice(0, 7); // Extract month and year
      } else {
        this.month = null;
      }
    },
  },

  methods: {
    getThisAcademicYear() {
      this.isLoading = true;
      axios.get('period/getThisPeriod')
        .then(res => {
          this.currentAcdYear = res.data;
          this.getAllHoliday();
          this.isLoading = false;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.month = null;
      this.selectedMonth = null;
      this.selectedCategory = null;
      this.selectedType = null;
      this.isLoading = true;
      this.getAllHoliday();
      this.isSearched = false;
    },

    searchHoliday(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      this.searchedData = {
        month: this.month,
        category_id: this.selectedCategory,
        type: this.selectedType
      };
      this.isSearched = true;
      axios.get('holiday/search?page=' + page, {
        params: {
          month: this.month,
          category_id: this.selectedCategory,
          type: this.selectedType,
        }
      })
        .then(res => {
          if (res.data) {
            this.holidayMasterData = res.data;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val, fieldName) {
      this.$set(this, fieldName, val);
    },

    selectEvent({
      id
    }, fieldName) {
      id == 'Select' ? this.$set(this, fieldName, '') : this.$set(this, fieldName, id);
    },

    getAllHoliday(page = 1) {
      axios.get('holiday/list?page=' + page, {
        params: {
          acd_year_start_date: this.currentAcdYear.start_date ?? null,
          acd_year_end_date: this.currentAcdYear.end_date ?? null,
        }
      }).then((response) => {
        this.holidayMasterData = response.data;
        this.isLoading = false;
      }).catch((error) => {
        if (error.response?.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.error('Error in getAllHoliday:', error);
      });
    },

    showCreate() {
      this.$router.push({
        path: "/holiday/create"
      });
    },

    showEdit(id) {
      this.$router.push({
        name: "holidayEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "holidayDetail",
        params: {
          id: id
        }
      });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deleteHoliday(id);
      } else {
        console.log("no");
      }
    },

    deleteHoliday(id) {
      this.isLoading = true;
      axios.delete("/holiday/delete/" + id)
        .then(response => {
          if (response.data.success == true) {
            this.getAllHoliday();
            this.$notification.success('Holiday Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error("Holiday data is already deleted.", {
              timer: 3,
              position: "bottomCenter"
            });
            this.getAllHoliday();
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Holiday Delete Error->", error.response.data);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData, category_id: this.selectedCategory, type: this.selectedType, search_status: this.search_status }
        : { acd_year_start_date: this.currentAcdYear.start_date ?? null, acd_year_end_date: this.currentAcdYear.end_date ?? null, category_id: this.selectedCategory, type: this.selectedType, search_status: this.search_status };
      axios.get('/holiday/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `holiday_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    getTemplateLink() {
      axios.get('holiday/getTemplateLink')
        .then(res => {
          this.templateLink = res.data;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    holidayCategoryLabel(row) {
      const id = row.category_id;
      if (id === null || id === undefined || id === "") {
        return "—";
      }
      const catId = Number(id);
      if (Number.isNaN(catId)) {
        return "—";
      }
      const cats = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
      const cat = cats.find((c) => Number(c.id) === catId);
      return cat ? cat.label : "—";
    },

    holidayCategoryColor(row) {
      const id = row.category_id;
      if (id === null || id === undefined || id === "") {
        return null;
      }
      const catId = Number(id);
      if (Number.isNaN(catId)) {
        return null;
      }
      const cats = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
      const cat = cats.find((c) => Number(c.id) === catId);
      return cat ? cat.color_code : null;
    },

    holidayTypeLabel(row) {
      const t = row.type;
      if (t === null || t === undefined || t === "") {
        return "—";
      }
      const opts = CONFIG.HOLIDAY_TYPE_OPTIONS || {};
      const num = Number(t);
      if (!Number.isNaN(num) && opts[num] !== undefined) {
        return opts[num];
      }
      if (opts[t] !== undefined) {
        console.log("opts[t]", opts[t]);
        return opts[t];
      }
      return "—";
    },

    downloadSchoolCalendar() {
      this.isLoading = true;
      axios.get('/holiday/download-school-calendar', {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          // school_calendar_current_yyyy_mm_dd_tuition_plan.pdf
          const fileName = `school_calendar_current_${date.getFullYear()}_${(date.getMonth() + 1).toString().padStart(2, '0')}_${date.getDate().toString().padStart(2, '0')}.pdf`;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.error("Download failed:", error);
        });
    },

    chooseFile() {
      this.$refs.fileUploader.value = '';
      document.getElementById('holiday-upload').click();
    },

    onHolidayFileChange() {
      this.invalidFile = false;
      let selectedFile = document.getElementById('holiday-upload').files;
      if (selectedFile.length) {
        let file = selectedFile[0];
        if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.holidayFileName = file.name;
          this.holidayFile = file;
        } else {
          this.invalidFile = true;
        }
      }
      this.disabled = false;
    },

    clearFile() {
      this.holidayFile = '';
      this.holidayFileName = '';
      this.invalidFile = false;
      this.disabled = false;
      this.submitted = false;
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.value = '';
      }
    },

    importFile() {
      this.submitted = true;
      this.disabled = false;

      if (!this.holidayFile) {
        this.disabled = false;
        return;
      }

      this.isLoading = true;
      let data = new FormData();
      data.append('holiday_xlsx', this.holidayFile);

      axios.post("holiday/import", data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        if (response.data.success == true) {
          this.$notification.success(response.data.msg, {
            timer: 3,
            position: "bottomCenter"
          });
          this.disabled = false;
          this.clearFile();
          this.getAllHoliday();
        } else {
          this.isLoading = false;
          this.disabled = false;
          this.clearFile();
          alert(response.data.msg);
        }
      }).catch(error => {
        this.isLoading = false;
        this.disabled = false;
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error('Error in import holiday:', error);
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getThisAcademicYear();
    this.getTemplateLink();
  },
};
